import { Map } from 'immutable';

import { DonationCreditRuleDto } from 'entities/donationCreditRule/dto';

import Api from '../api';

import DonationCreditRule from './model';
import { addAction, addMultipleAction, removeAction, updateAction } from './actions';

export default class DonationCreditRulesApi {
  static fetchAll() {
    return Api.get<DonationCreditRuleDto[]>('api/donationCreditRules').map((rules) =>
      addMultipleAction(Map(rules.map((rule) => [rule.id, new DonationCreditRule(rule)])))
    );
  }

  static fetch(id: string) {
    return Api.get<DonationCreditRuleDto>(`api/donationCreditRules/${id}`).map((rule) =>
      addAction(new DonationCreditRule(rule))
    );
  }

  static create(data) {
    return Api.post('api/donationCreditRules', data).map((donationCreditRule) =>
      addAction(new DonationCreditRule(donationCreditRule))
    );
  }

  static update(id: string, data) {
    return Api.patch<DonationCreditRuleDto>(`api/donationCreditRules/${id}`, data).map(
      (donationCreditRule) => updateAction(new DonationCreditRule(donationCreditRule))
    );
  }

  static delete(id: string) {
    return Api.delete(`api/donationCreditRules/${id}`).map(() => removeAction(id));
  }
}
